import { render, staticRenderFns } from "./modalFiltroPasarela.vue?vue&type=template&id=6770677e"
import script from "./modalFiltroPasarela.vue?vue&type=script&lang=js"
export * from "./modalFiltroPasarela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports